import ChanelBottomBanner from 'components/ChanelBottomBanner/ChanelBottomBanner';

export default ChanelBottomBanner;
